module.exports = __webpack_public_path__ + "static/media/quitasol.33312bb4.png";